import { Config } from '../video-data/config';

/**
 * Calculate the individual duration for each text length based on our global reading speed and the given duration.
 * given duration.
 * @param textLengths - an array of text lengths represented by a number
 * @param duration - the total allocated time to read the given text array
 */
const calculateReadingDurations = (textLengths: number[], duration: number): number[] => {
    if (textLengths.length === 0) {
        return [];
    }
    if (textLengths.length <= 1) {
        return [duration];
    }
    const readingDurations = textLengths.map((textLength) => {
        let duration = (textLength / Config.DEFAULT_READING_SPEED) * 1000;
        duration = Math.min(Config.MAX_RECOMMENDED_SUBSCENE_DURATION, duration);
        return Math.max(Config.MIN_RECOMMENDED_SUBSCENE_DURATION, duration);
    });

    const totalDuration = readingDurations.reduce((a, b) => a + b, 0);
    const newDurations = readingDurations.map((readingDuration) => {
        return Math.round((readingDuration / totalDuration) * duration);
    });

    // due to round errors our total duration can be different, account for this here
    const newDurationsSum = newDurations.reduce((a, b) => a + b, 0);
    if (newDurationsSum !== duration) {
        const difference = newDurationsSum - duration;
        newDurations[newDurations.length - 1] -= difference;
    }

    newDurations.forEach((duration) => {
        if (duration < Config.MIN_SCENE_DURATION) {
            throw Error("Can't determine a valid duration");
        }
    });

    return newDurations;
};

export default calculateReadingDurations;
